import {
  INTERBRANCH_PATIENT_DETAILS,
  INTERBRANCH_CLINIC_SPECIALITY,
  INTERBRANCH_REGISTER_PATIENT,
  INTERBRANCH_CONSULTATION,
  INTERBRANCH_READ_PATIENT_PROFILE,
  INTERBRANCH_CLINIC_SPECIALITY_DOCTORLIST,
  INTERBRANCH_UPDATE_PATIENT_BASICINFO,
  INTERBRANCH_UPDATE_PATIENT_MEDINFO,
  INTERBRANCH_INSERT,
  INTERBRANCH_APPOINTMENT_HISTORY,
  INTERBRANCH_DETAILED_CONSULTATION,
  INTERBRANCH_COUPON_VERIFICATION,
  INTERBRANCH_STORE_APPOINMENT_FORM_DATA,
  INTERBRANCH_MODAL_UPDATE,
  INTERBRANCH_UPLOAD_REPORTS,
  INTERBRANCH_UPLOAD_REPORTS_UPDATE,
  INTERBRANCH_UPDATE_LIFESTYLE_PREEXISTING_INFO,
  INTERBRANCH_UPDATE_MEDIACATION_ALLERGY_INFO,
  INTERBRANCH_LIFESTYLE_UPDATE,
  INTERBRANCH_CONDITIONS_UPDATE,
  INTERBRANCH_APPOINTMENT_STATUS,
  INTERBRANCH_UPDATE_TEMP_APPOINTMENT_FORM,
  INTERBRANCH_CLEAR_TEMP_APPOINTMENT_FORM,
  FETCH_PATIENTS_CONSULTATION_DETAILS,
  INTERBRANCH_ADD_APPOINMENT_FORM_DATA
} from "../actions/type";
import { appointmentBook } from "../components/Constants/InterBranchBookAppointmentData";
import { ADD_DATA_TO_ALLERGY_MEDICATION_REDUX, CLEAR_INTERBRANCH_APPOINTMENT_FORM, CLEAR_INTERBRANCH_DATA, EDIT_DATA_TO_ALLERGY_MEDICATION_REDUX, REMOVE_DATA_FROM_ALLERGY_MEDICATION_REDUX, SAVE_INTERBRANCH_APPOINTMENT_FORM_BOOK, SAVE_INTERBRANCH_APPOINTMENT_FORM_SCHEDULE } from "../Helpers/InterBranchConstants";

const INITIAL_STATE = {

  appointment_form: appointmentBook,
  reportsUploaded: [],
  saved_book_appointment_form: null,
  saved_schedule_appointment_form: null,
  modals: {
    deleteAllergy: { isVisible: false, data: null },
    deleteMedication: { isVisible: false, data: null },
    consultationHistory: { isVisible: false, data: null },
    patientconsultationHistory: { isVisible: false, data: null },
    ViewFileModal: { isVisible: false, data: null },
    removeFileModal: { isVisible: false, data: null },
    switchFromBook: { isVisible: false, data: null },
    switchFromSchedule: { isVisible: false, data: null },
    commomAlertModal: { isVisible: false, data: null }
  },
  temp_appointment_form: null

};

export default (state = INITIAL_STATE, { type, payload }) => {

  switch (type) {
    case INTERBRANCH_CLINIC_SPECIALITY:
      return {
        ...state,
        interBranchClinicSpeciality: payload
      };
    case INTERBRANCH_CONSULTATION:
      return {
        ...state,
        interBranchConsultation: payload
      };
    case INTERBRANCH_REGISTER_PATIENT:
      return {
        ...state,
        interBranchRegisterPatient: payload
      };
    case INTERBRANCH_PATIENT_DETAILS:
      return {
        ...state,
        interBranchPatientDetails: payload
      };
    case INTERBRANCH_READ_PATIENT_PROFILE:
      return {
        ...state,
        interBranchReadPatientProfile: payload
      };
    case INTERBRANCH_CLINIC_SPECIALITY_DOCTORLIST:
      return {
        ...state,
        interBranchClinicSpecialityDoctorList: payload
      };
    case INTERBRANCH_UPDATE_PATIENT_BASICINFO:
      return {
        ...state,
        interBranchUpdatePatientBasicinfo: payload
      };
    case INTERBRANCH_UPDATE_LIFESTYLE_PREEXISTING_INFO:
      return {
        ...state,
        interBranchUpdateLifeStylePreExistingInfo: payload
      };
    case INTERBRANCH_UPDATE_MEDIACATION_ALLERGY_INFO:
      return {
        ...state,
        interBranchUpdateMedicationAllergyInfo: payload
      };
    case INTERBRANCH_UPDATE_PATIENT_MEDINFO:
      return {
        ...state,
        interBranchUpdatePatientMedinfo: payload
      };
    case FETCH_PATIENTS_CONSULTATION_DETAILS:
      return {
        ...state,
        consultationdetails: payload
      };
    case INTERBRANCH_INSERT:
      return {
        ...state,
        interBranchInsert: payload
      };
    case INTERBRANCH_APPOINTMENT_HISTORY:
      return {
        ...state,
        interBranchAppointmentHistory: payload
      };
    case INTERBRANCH_UPLOAD_REPORTS:

      return {
        ...state,
        temp_appointment_form: { ...state.temp_appointment_form, reportsUploaded: payload },

      };
    case INTERBRANCH_UPLOAD_REPORTS_UPDATE:

      return {
        ...state,
        temp_appointment_form: { ...state.temp_appointment_form, reportsUploaded: payload },
      };
    case INTERBRANCH_DETAILED_CONSULTATION:
      return {
        ...state,
        interBranchDetailedConsultation: payload
      };
    case INTERBRANCH_COUPON_VERIFICATION:
      return {
        ...state,
        interBranchCouponStatus: payload
      };

    case INTERBRANCH_STORE_APPOINMENT_FORM_DATA:

      return {
        ...state, appointment_form: { ...state.appointment_form, ...payload }
      };


    case CLEAR_INTERBRANCH_APPOINTMENT_FORM:

      return {
        ...state, appointment_form: INITIAL_STATE.appointment_form,
      };

    case SAVE_INTERBRANCH_APPOINTMENT_FORM_BOOK:

      return {
        ...state,
        saved_book_appointment_form: state.appointment_form
      };
    case SAVE_INTERBRANCH_APPOINTMENT_FORM_SCHEDULE:

      return {
        ...state,
        saved_schedule_appointment_form: state.appointment_form
      };

    case INTERBRANCH_MODAL_UPDATE:

      //payload format = { modalName:"", isVisible:true, data:{id:123}}
      let newModals = state.modals
      newModals[payload.modalName] = { isVisible: payload.isVisible, data: payload.data }
      return {
        ...state,
        modals: newModals
      };

    case INTERBRANCH_LIFESTYLE_UPDATE:

      //payload format = { modalName:"", isVisible:true, data:{id:123}}
      let patientLifestyles = { ...state.appointment_form.patientLifeStyles }
      patientLifestyles[payload.key] = payload.value
      return {
        ...state,
        appointment_form: { ...state.appointment_form, patientLifeStyles: patientLifestyles }
      };
    case INTERBRANCH_CONDITIONS_UPDATE:
      // console.log("Inside INTERBRANCH_CONDITIONS_UPDATE",payload)
      //payload format = { modalName:"", isVisible:true, data:{id:123}}
      let conditions = { ...state.appointment_form.patientPreExistingConditions }
      conditions[payload.key][payload.parent] = payload.value
      return {
        ...state,
        appointment_form: { ...state.appointment_form, patientPreExistingConditions: conditions }
      };

    case ADD_DATA_TO_ALLERGY_MEDICATION_REDUX:

      let newState = state.allergiesAndMedications
      newState[payload.stateName] = [...newState[payload.stateName], payload.data]

      return {
        ...state,
        allergiesAndMedications: newState
      };
    case EDIT_DATA_TO_ALLERGY_MEDICATION_REDUX:


      let newStateEditter = state.temp_appointment_form[payload.stateName]
      let editArray = [...newStateEditter]
      editArray.map((each) => {
        if (each.index == payload.index) {
          each[payload.key] = payload.value
        }
      })


      return {
        ...state,
        temp_appointment_form: { ...state.temp_appointment_form, [payload.stateName]: editArray }
      };
    case REMOVE_DATA_FROM_ALLERGY_MEDICATION_REDUX:

      const { stateName, index } = payload
      let removeArray = state.temp_appointment_form[stateName]
      let filteredArray = removeArray.filter((eachItem) => eachItem.index != index)

      return {
        ...state,
        temp_appointment_form: { ...state.temp_appointment_form, [stateName]: filteredArray }
      };
    case CLEAR_INTERBRANCH_DATA:

      return INITIAL_STATE;

    case INTERBRANCH_APPOINTMENT_STATUS:
      return {
        ...state,
        interBranchAppointmentBookStatus: payload
      };

    case INTERBRANCH_UPDATE_TEMP_APPOINTMENT_FORM:
      return {
        ...state,
        temp_appointment_form: state.temp_appointment_form ? { ...state.temp_appointment_form, ...payload } : payload
      };

    case INTERBRANCH_CLEAR_TEMP_APPOINTMENT_FORM:
      return {
        ...state,
        temp_appointment_form: null
      };

    default:
      return state;
  }


};
